const o = "/api/dashboard/customer", e = "/api/dashboard/customer/data-files", _ = `${e}/validate-and-get-upload-options`, i = (t) => `${e}/${t}/activate-file`, s = (t) => `${o}/draft-file/${t}`, A = "/api/data-files", n = `${A}/validate-and-get-upload-options`, P = (t) => `${A}/${t}/activate-file`, a = "/api/dashboard/management/data-files", c = `${a}/validate-and-get-upload-options`, d = (t) => `${a}/${t}/activate-file`, I = (t) => `${a}/${t}/delete-draft`;
export {
  a as COMMON_DATA_FILES_API_BASE_PATH,
  c as COMMON_DATA_FILES_VALIDATION_API_PATH,
  o as CUSTOMER_API_BASE_PATH,
  e as DATA_FILES_API_BASE_PATH,
  _ as DATA_FILES_VALIDATION_API_PATH,
  A as PUBLIC_DATA_FILES_API_BASE_PATH,
  n as PUBLIC_DATA_FILES_VALIDATION_API_PATH,
  d as getActivateCommonFilePath,
  i as getActivateFilePath,
  P as getActivatePublicFilePath,
  I as getRemoveDraftCommonFilePath,
  s as getRemoveDraftFilePath
};
